import { Tool } from './tool.js';
import { BrushStroke } from '../../scene/stroke/brush.js';
import * as glMatrix from '../../../../node_modules/gl-matrix';
export class GumTool extends Tool {
    _size: number;
    _hardness: number;
    _color: glMatrix.vec4;
    edit: boolean;
    stroke: BrushStroke;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'brush', 'Gomme');
        var self = this;
        try {
            self._size = JSON.parse(window.localStorage.getItem('PSGumTool_size') || '');
            if (isNaN(self._size) || self._size === null) {
                self._size = 200;
            }
        } catch (e) {
            self._size = 200;
        }
        try {
            self._hardness = JSON.parse(window.localStorage.getItem('PSGumTool_hardness') || '');
            if (isNaN(self._hardness) || self._hardness === null) {
                self._hardness = 0.5;
            }
        } catch (e) {
            self._hardness = 0.5;
        }
        self._color = glMatrix.vec4.create();
        self.edit = false;
        self.stroke = new BrushStroke(gl, width, height);
    }

    get size() {
        return this._size;
    }

    set size(value) {
        try {
            window.localStorage.setItem('PSGumTool_size', value.toString());
        } catch (e) {
        }
        this._size = value;
    }

    get hardness() {
        return this._hardness;
    }

    set hardness(value) {
        try {
            window.localStorage.setItem('PSGumTool_hardness', value.toString());
        } catch (e) {
        }
        this._hardness = value;
    }

    get color() {
        return this._color;
    }

    destroy() {
        super.destroy();
        this.stroke.destroy();
    }

    static copy(value) {
        var result = new GumTool(value._gl, value._width, value._height);
        result.size = value.size;
        result.hardness = value.hardness;
        result.edit = value.edit;
        return result;
    }

    addPoint(point) {
        var self = this;
        self.stroke.addPoint(point, self.size / self._width);
        self._touch = true;
    }
}
